// @ts-nocheck
// Support on Safari 15.4
'hasOwn' in Object || (Object.hasOwn = Object.call.bind(Object.hasOwnProperty));
